'use strict';
var base = require('./base');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
        '<div class="add-to-wishlist-messages "></div>'
        );
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
        button.removeAttr('disabled');
    }, 5000);
}

module.exports = {
    availability: base.availability,

    addToCart: base.addToCart,

    collapse: $('.collapse').collapse("hide"),

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }

            if (data.viInventoryDateExpected) {
                $('.inventory-date-expected').removeClass('d-none');
                $('.inventory-expected-date').html(data.viInventoryDateExpected)
            } else {
                $('.inventory-date-expected').addClass('d-none') 
            }

            if (data.lowestPrice) {
                $('.lowprice').removeClass('d-none');
                $('#lowpriceText').html(data.lowestPrice.text);
            } else {
                $('.lowprice').addClass('d-none') 
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                $('.product-detail').data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                $('.product-detail').data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $($('.product-detail:not(".bundle-item")')[0]).attr('data-pid', response.data.product.id);
                $($('.product-detail:not(".bundle-item")')[1]).attr('data-pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

                $(".add-to-cart.btn .outstock-standard").addClass("d-none");
                // in stock
                if(response.product.readyToOrder == true && response.product.available == true){
                    $(".inventory-instock").removeClass("d-none");
                    $(".add-to-cart.btn .instock").removeClass("d-none");
                    $(".add-to-cart.btn .outstock").addClass("d-none");
                }else{
                    $(".inventory-instock").addClass("d-none");
                    $(".add-to-cart.btn .instock").addClass("d-none");
                    $(".add-to-cart.btn .outstock").removeClass("d-none");
                }
                // out of stock
                if(response.product.readyToOrder == true && response.product.available == false){
                    $(".inventory-outstock").removeClass("d-none");
                }else{
                    $(".inventory-outstock").addClass("d-none");
                }

                // avaliable in store
                if(response.product.tags.CPHinStock == true){
                    $(".inventory-instock-store").removeClass("d-none");
                }else{
                    $(".inventory-instock-store").addClass("d-none");
                }

            var enable = response.$productContainer.find('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global').attr('disabled', !enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.product-msg-availability').remove();

            if($('.filter-option-inner-inner').find('span.custom-select-text').length > 0) {
                $('.filter-option-inner-inner').find('span.custom-select-text')
                .each(function () {
                    $(this).remove();
                })
            }
            if (!response.product.available) {
                var labelSelectSize = $(window).width() < 768 ? $($('.selectpicker').find('option:selected')[1]).hasClass('js-label-select-size') : $($('.selectpicker').find('option:selected')[0]).hasClass('js-label-select-size');
                if ($('.color-attribute.selected').length > 0 && !labelSelectSize) {
                    base.outOfStockMessage(response.product.availability.messages[0]);
                }
            }
            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

    addToWishlist: function () {
        $('.add-to-wish-list').on('click', function (e) {
            e.preventDefault();
            var url = $(this).data('href');
            var button = $(this);
            var pid = $(this).closest('.product-detail').data('pid');
            if (!pid) {
                return;
            }

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid
                },
                success: function (data) {
                    displayMessage(data, button);
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });
    },

    addToStockNotification: function() {
        $('.add-to-stock-notification').on('click', function (e) {
            var url = $(this).data('href');
            var pid = $(this).closest('.product-detail').data('pid');
            var button = $(this);
            var stockNotificationEmail = $('#stockNotificationEmail').val();
            var stockNotificationAccountInfo = $('#stockNotificationAccountInfo').val();
            var stockNotificationSignup = $('#stockNotificationSignup').is(':checked');
            
            $('#getNotifiedModal').modal('hide');
            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    stockNotificationEmail: stockNotificationEmail,
                    stockNotificationAccountInfo: stockNotificationAccountInfo,
                    stockNotificationSignup: stockNotificationSignup
                },
                success: function (data) {
                    displayMessage(data, button);
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });
    },

    moveToDescription : function() {
        $('.js-show-more').on('click', function(e) {
            var position = $('.cc-product-dad').offset().top
            $('html, body').animate({
                scrollTop: position * 0.9
            }, 500);
        });
    },


    hideNullProducts () {
        setTimeout(function(){
            $('.product-tile').each(function() {
                let pid = $(this).parent('.product').data('pid');
                if (pid == null) {
                    $(this).parent().parent().hide();
                }
            });
        }, 500);
        $(window).scroll(function() {
            $('.product-tile').each(function() {
                let pid = $(this).parent('.product').data('pid');
                if (pid == null) {
                    $(this).parent().parent().hide();
                }
            });
        });
    }
};

$(document).ready(function () {
    $('body').on('click', '.product-detail:not(.product-quickview) .primary-images+div .attributes .color-attribute', function() {
        $('.product-detail:not(.product-quickview) .primary-images+div .attributes .color-attribute').removeClass('selected');
        $(this).addClass('selected');
    });

    $('body').on('click', '.product-detail:not(.product-quickview) .color-attribute', function() {
        $('.product-detail:not(.product-quickview) .color-attribute').removeClass('selected');
        $(this).addClass('selected');
    });
});

$(document).ready(function () {
    var message = $('#message').val();
    var labelSelectSize = $(window).width() < 768 ? $($('.select-size')[1]).find(':selected').hasClass('js-label-select-size') : $($('.select-size')[0]).find(':selected').hasClass('js-label-select-size');

    if (message && $('.color-attribute.selected').length > 0 && !labelSelectSize) {
        base.outOfStockMessage(message);
    }
   base.initSlider();
});

$(document).on('click', '.link360', function(event) { 
    event.preventDefault(); 
    $('.click360').click(); 
    $('.link360').hide();
    $('.hasvideo .linkvideo').show();
    $('.linkimages').show();
});
$(document).on('click', '.linkvideo', function(event) { 
    event.preventDefault(); 
    $('.clickvideo').click(); 
    $('.linkvideo').hide();
    $('.linkimages').show();
    $('.has360 .link360').show();
});
$(document).on('click', '.linkimages', function(event) { 
    event.preventDefault(); 
    $('#thumbnail-slider-slide01').click(); 
    $('.linkimages').hide();
    $('.hasvideo .linkvideo').show();
    $('.has360 .link360').show();
});

/* GPSR SPECS */
window.onload = function() {
    var toggleButton = document.getElementById('toggleButton');
    var producerInfo = document.getElementById('producerInfo');
    var chevronIcon = document.getElementById('chevronIcon');

    toggleButton.onclick = function() {
        producerInfo.classList.toggle('d-none');
        var currentRotation = chevronIcon.style.transform;
        chevronIcon.style.transform = currentRotation === 'rotate(180deg)' ? 'rotate(0deg)' : 'rotate(180deg)';
    };
};


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/product/detail.js